<template>
  <div class="checkout-footer-section">
    <div class="checkout-footer-wrapper">
      <div class="checkout-footer-logo">
        <img src="@/assets/logo.svg" alt="Ninja Skins Logo" class="checkout-footer-logo-img" />
      </div>
      <div class="checkout-footer-info">
        <ul class="checkout-footer-list">
          <li class="checkout-footer-list__item">
            Support: <a :href="`mailto:${supportEmail}`">{{ supportEmail }}</a>
          </li>
          <li class="checkout-footer-list__item">
            <pre class="checkout-footer-pre">{{ requisites }}</pre>
          </li>
        </ul>
        <div class="checkout-footer-copyright">
          {{ copyright }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'CheckoutFooter',
  computed: {
    ...mapGetters('settings', ['requisites', 'supportEmail', 'copyright'])
  },
  methods: {
    ...mapActions('settings', ['fetchSettings'])
  },
  mounted() {
    if (!this.requisites || !this.supportEmail || !this.copyright) {
      this.fetchSettings();
    }
  }
}
</script>

<style scoped>
.checkout-footer-section {
  width: 100%;
  background: transparent;
  padding: 40px 0 24px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  flex-direction: column;
}
.checkout-footer-wrapper {
  width: 100%;
  max-width: 900px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.checkout-footer-logo {
  display: flex;
  justify-content: center;
  margin-bottom: 32px;
}
.checkout-footer-logo-img {
  height: 48px;
  width: auto;
}
.checkout-footer-info {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.checkout-footer-list {
  list-style: none;
  padding: 0;
  margin: 0 0 16px 0;
  width: 100%;
  text-align: center;
}
.checkout-footer-list__item {
  font-size: 15px;
  line-height: 1.7;
  margin-bottom: 8px;
  white-space: pre-line;
}
.checkout-footer-pre {
  white-space: pre-line;
  font-size: 15px;
  background: none;
  border: none;
  padding: 0;
  margin: 0;
}
.checkout-footer-copyright {
  font-size: 13px;
  opacity: 0.7;
  margin-top: 8px;
  text-align: center;
}
</style>
